module.exports = __webpack_public_path__ + "img/tree-large.3505654c.svg";